import * as React from 'react';

type Props = {
  rel: string;
  href: string;
};
const LinkTag = (props: Props): null => {
  const link = document.createElement('link');
  link.rel = props.rel;
  link.href = props.href;
  React.useEffect(() => {
    document.head.appendChild(link);
  });
  return null;
};

export default LinkTag;
